import exp from "constants";
import { useTranslation } from "react-i18next"

const useTabsTeuda = () => {
  const [t] = useTranslation("teudot");
  const TAB_LIST = [t("teudot_create_page_tabs_taken"), t("teudot_create_page_tabs_rest")];
  return { TAB_LIST };
} 

export default useTabsTeuda;